module.exports = __webpack_public_path__ + "img/kf.1a598aca.png";